function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "alerta",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_384",
  "data-name": "Caminho 384",
  d: "M7.159,1.579,5.58,0a19.052,19.052,0,0,0,0,26.943l1.579-1.579a16.819,16.819,0,0,1,0-23.786Zm0,0",
  transform: "translate(0 0)",
  fill: "#ba122b"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_385",
  "data-name": "Caminho 385",
  d: "M64.277,42.488a14.564,14.564,0,0,0,0,20.619l1.579-1.579a12.332,12.332,0,0,1,0-17.462Zm0,0",
  transform: "translate(-55.535 -39.327)",
  fill: "#ba122b"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_386",
  "data-name": "Caminho 386",
  d: "M417.384,0l-1.579,1.579a16.819,16.819,0,0,1,0,23.786l1.579,1.579a19.052,19.052,0,0,0,0-26.943Zm0,0",
  transform: "translate(-384.861)",
  fill: "#ba122b"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_387",
  "data-name": "Caminho 387",
  d: "M374.9,42.488l-1.579,1.579a12.332,12.332,0,0,1,0,17.462l1.579,1.579a14.564,14.564,0,0,0,0-20.619Zm0,0",
  transform: "translate(-345.538 -39.326)",
  fill: "#ba122b"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_388",
  "data-name": "Caminho 388",
  d: "M219.164,10.606h5.483V25.481h-5.483Zm0,0",
  transform: "translate(-202.854 -9.817)",
  fill: "#ba122b"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_389",
  "data-name": "Caminho 389",
  d: "M219.164,277.758h5.483v5.483h-5.483Zm0,0",
  transform: "translate(-202.854 -257.088)",
  fill: "#ba122b"
}));

function SvgAlerta(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.103,
    height: 26.943,
    viewBox: "0 0 38.103 26.943",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlerta);
export default __webpack_public_path__ + "static/media/Alerta.32b971e0.svg";
export { ForwardRef as ReactComponent };